export default {
  plansOrder(state) {
    return state.plans.sort((a, b) => (a.order > b.order ? 1 : -1));
  },
};
